import { Container } from 'react-bootstrap';
import Banner from '../../Component/Banner';
import Footer from '../../Content/Footer';

function checkLightMode() {
    if (sessionStorage.getItem('lightMode') === 'true')  {
      return true
    }
  }

const June2026 = () => {

    return (
            <>
                <Container>
                    <Banner caption="June 2026 Birthdays" />

                    <div className="theme-dashboard">
                        
                        {/* 🌊 PRIM CARD */}
                        <a href="/QuizTrivias/June2026/Prim" className="theme-card prim-card">
                            <h1>Primrose's 7th Birthday</h1>
                        </a>

                        {/* 🟡 PAPA LADZ CARD */}
                        <a href="/QuizTrivias/June2026/PapaLads" className="theme-card papa-card">
                            <h1>Papa Ladz's 70th Birthday</h1>
                        </a>

                    </div>

                </Container>
                <Footer testProps= { checkLightMode() ? "lightMode" : "darkMode" }/>
            </>
    )
}

export default June2026;